import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ResetPassword from "./ResetPassword";

const ResetPasswordLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Reset Password" />
      <ResetPassword />
    </MasterLayout>
  );
};

export default ResetPasswordLayout;
